import { FloodLightsActions } from 'actions/FloodLightsAction';
export default function (state = { visible: false, isClickTriggered: false }, action) {
    switch (action.type) {
        case FloodLightsActions.FLOOD_LIGHTS_VISIBILITY:
            return Object.assign({}, state, { visible: action.visible });
        case FloodLightsActions.FLOOD_LIGHTS_EVENT_NAME:
            return Object.assign({}, state, {
                eventName: action.eventName || state.eventName,
                isClickTriggered: action.isClickTriggered,
                productId: action.productId || state.productId
            });
        default:
            return state;
    }
}
